import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import PropTypes from 'prop-types';
import Card from '../cards/Card';
import {
  getMoodReasons,
  getOrganizationFeaturesRequest,
  sendMoodRequest
} from '../../../helpers/api';
import { routes } from '../../../assets/routes';
import { useHistory } from 'react-router-dom';
import mood1 from '../../../assets/icons/moodTracker/mood1.svg';
import mood2 from '../../../assets/icons/moodTracker/mood2.svg';
import mood3 from '../../../assets/icons/moodTracker/mood3.svg';
import mood4 from '../../../assets/icons/moodTracker/mood4.svg';
import mood5 from '../../../assets/icons/moodTracker/mood5.svg';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { Alert, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import classNames from 'classnames';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useTranslation } from '../../../i18n/LanguageProvider';

const AddCurrentMood = (props) => {
  const { t } = useTranslation();
  const [placeHolder] = useState(() => {
    const sentences = t('mood.examples.neutral');
    return (
      t('mood.examplePrefix') +
      sentences[Math.floor(Math.random() * sentences.length)]
    );
  });

  const moods = [
    [mood5, 5],
    [mood4, 4],
    [mood3, 3],
    [mood2, 2],
    [mood1, 1]
  ];
  const history = useHistory();
  const [selectedMood, setSelectedMood] = useState(null);
  const [selectedReason, setSelectedReason] = useState(null);
  const [moodComment, setMoodComment] = useState(null);
  const [anonymous, setAnonymous] = useState(true);
  const [reasons, setReasons] = useState([]);

  const sendMoodMutation = useMutation(sendMoodRequest, {
    onSuccess() {
      props.reloadAvgMoodTracker?.();
      toast.success(t('mood.submitted'));
      if (!props.homePage) {
        history.push(routes.HOME);
      }
    },
    onError(e) {
      toast.error(e.response?.data.detail || t('mood.submitError'));
    }
  });

  const getMoodReasonMutation = useMutation(getMoodReasons, {
    onSuccess(response) {
      setReasons(response.map((moodReason) => moodReason.reason));
    },
    onError(e) {
      toast.error(e.response?.data.detail || t('mood.reasonsError'));
    }
  });

  useEffect(() => {
    getMoodReasonMutation.mutate();
  }, []);

  const { data: orgFeatures } = useQuery(
    ['organizationFeatures'],
    getOrganizationFeaturesRequest
  );

  const defaultAnonymos = orgFeatures?.data?.find(
    (feature) => feature.feature_name === 'secret_mood'
  )?.active;

  const secretPropmt = defaultAnonymos
    ? t('mood.showNameToHr')
    : t('mood.hideNameFromHr');

  return (
    <div className={styles.currentMood}>
      <div className={styles.text}>
        <div className={styles.question}>{t('mood.todayQuestion')}</div>
        {props.homePage ? (
          <div
            className={styles.link}
            onClick={() => {
              history.push(routes.MOOD_TRACKER);
            }}
          >
            <span>{t('mood.details')}</span>
            <ArrowBackIosRoundedIcon className="flip-ltr" />
          </div>
        ) : null}
      </div>
      <Card extraClass={styles.box} noPointer>
        {moods.map((mood, index) => (
          <Card
            key={index}
            selected={selectedMood === mood[1] ? true : false}
            extraClass={styles.card}
          >
            <img
              src={mood[0]}
              onClick={() => {
                setSelectedMood(mood[1]);
                if (props.homePage) {
                  sendMoodMutation.mutate({
                    mood: mood[1]
                  });
                }
              }}
            />
          </Card>
        ))}
      </Card>
      {!props.homePage && selectedMood && (
        <>
          <div className={styles.reasonsBox}>
            {reasons.map((reason) => (
              <Card
                extraClass={classNames(
                  styles.reasonCard,
                  selectedReason === reason && styles.selected
                )}
                key={reason}
                selected={selectedReason === reason}
                onClick={() => {
                  if (selectedReason === reason) {
                    setSelectedReason(null);
                    return;
                  }
                  setSelectedReason(reason);
                }}
              >
                <span>{reason}</span>
              </Card>
            ))}
          </div>
          <div className={styles.noteBox}>
            <TextField
              id="give-kudos"
              name="give-kudos"
              multiline
              hiddenLabel
              className={styles.note}
              value={moodComment}
              onChange={(e) => setMoodComment(e.target.value)}
              fullWidth
              placeholder={placeHolder}
            />
            {anonymous && defaultAnonymos && (
              <Alert variant="outlined" severity="info" sx={{ mt: 1 }}>
                {t('mood.anonymousHint')}
              </Alert>
            )}

            {defaultAnonymos && (
              <FormControlLabel
                label={secretPropmt}
                control={
                  <Checkbox
                    checked={!anonymous}
                    onChange={() => setAnonymous(!anonymous)}
                  />
                }
              />
            )}
          </div>
          <Button
            variant="contained"
            disabled={!selectedMood}
            loading={sendMoodMutation.isLoading}
            onClick={() =>
              sendMoodMutation.mutate({
                mood: selectedMood,
                comment: moodComment,
                reason: selectedReason,
                anonymous: defaultAnonymos ? anonymous : !anonymous
              })
            }
            className={styles.sendButton}
            fullWidth
          >
            <span>{t('common.submit')}</span>
          </Button>
        </>
      )}
    </div>
  );
};
AddCurrentMood.propTypes = {
  homePage: PropTypes.bool,
  reloadAvgMoodTracker: PropTypes.func
};

export default AddCurrentMood;
